/**
 * Normalizes repeated query values into unique strings. Comma-separated
 * strings are split unless values may contain commas themselves, such as
 * Discogs genres like "Folk, World, & Country".
 */
export function queryValues(value: unknown, splitCommas = true): string[] {
	const values = Array.isArray(value) ? value : [value]
	return [
		...new Set(
			values
				.flatMap((item) =>
					typeof item !== 'string'
						? []
						: splitCommas
							? item.split(',')
							: [item],
				)
				.map((item) => item.trim())
				.filter(Boolean),
		),
	]
}
